import React, {Component} from "react";
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

class HomeUserSlider extends Component {
    constructor(props) {
      super(props);
    }
    componentDidMount(){
      window['srbSlider']();
    }
    render() {
        const { t } = this.props;
  		return (

        <div className="send-money-area srbcarousel pd-top-36 pd-bottom-40 mg-top-40 bg-theme">
          <div className="container">
              <div className="section-title style-two">
                  <h3 className="title">{t('lang.home_sc_employee')}</h3>
                  <Link to={'/employeelist'}>{t('lang.home_sc_view_all')}</Link>
              </div>
          </div>

	    	<div className="send-money-slider owl-carousel">
             {this.props.user_list_carousel.map(({ id, first_name, last_name, profile_image }) => (    
                <div className="item" key={id}>
                    <div className="single-send-money">
                    <Link to={ (localStorage.getItem('user_type') !== 'user') ? '/employee-profile/'+id : '#' }>
                        <img src={profile_image} alt="img" />
                        <p className="text-overflow">{first_name} {last_name}</p>
                      </Link>
                    </div>
                </div>
              ))}
          </div>
        </div>
	    )}
  	
}

export default withTranslation('common')(HomeUserSlider);